import { Component, State, Element, Event, EventEmitter, Prop, h } from '@stencil/core';
import datepicker from 'js-datepicker'
import { overrideSettings } from '../../utils/utils';

@Component({
  tag: 'fdi-date-time-picker',
  styleUrl: 'fdi-date-time-picker.scss',
  shadow: true,
})
export class FdiDateTimePicker {

  @Prop() __settings: any;
  @Prop() __datetime: string = undefined;
  @Prop() __dateonly: boolean = false;

  @State() picker: any;
  @State() date: string;
  @State() time: string = '1:00';
  @State() station: string = 'PM';
  @State() timezone: string = 'None';
  @State() settings: any = {
    meta: {}
  };

  @Element() private element: HTMLElement;

  @Event({
    eventName: 'fdi_wc_datetimepicker_change',
    bubbles: true,
    cancelable: true,
  }) dateTimeChanged: EventEmitter

  componentDidLoad() {
    const datetime = new Date();
    const [date,time,station,timezone] = this.__datetime ? this.__datetime.split( ' ' ) : [undefined,undefined,undefined,undefined];
    if ( time ) {
      this.time = time;
    }
    if ( station ) {
      this.station = station;
    }
    if ( timezone ) {
      this.timezone = timezone;
    }
    const today = new Date( datetime.getFullYear(), datetime.getMonth(), datetime.getDate() );
    this.date = date ? date : today.toLocaleDateString();
    this.picker = datepicker(this.element.shadowRoot.getElementById( 'datepicker'), { // https://www.npmjs.com/package/js-datepicker
      minDate: today,
      dateSelected: this.date ? new Date( this.date ) : today,
      formatter: (input, date) => {
        input.value = date.toLocaleDateString()
      },
      onSelect: (instance, date) => {
        this.date = date.toLocaleDateString();
        console.log({value: this.getValue(), instance})
        this.dateTimeChanged.emit({
          newValue: this.getValue(),
          meta: this.settings.meta,
        });
      }
    });
    this.dateTimeChanged.emit({
      newValue: this.getValue(),
      meta: this.settings.meta,
    });
  }

  getValue() {
    return this.__dateonly ? this.date.trim() : `${this.date} ${this.time} ${this.station} ${this.timezone}`.trim();
  }

  handleTimezoneChange(e) {
    this.timezone = e.target.value;
    this.dateTimeChanged.emit({
      newValue: this.getValue(),
      meta: this.settings.meta,
    });
  }

  handleStationChange(e) {
    this.station = e.target.value;
    this.dateTimeChanged.emit({
      newValue: this.getValue(),
      meta: this.settings.meta,
    });
  }

  handleTimeChange(e) {
    this.time = e.target.value;
    this.dateTimeChanged.emit({
      newValue: this.getValue(),
      meta: this.settings.meta,
    });
  } 
  
  componentWillLoad() {
    let settings = this.__settings;

    if ( typeof settings === 'string' ){
      settings = JSON.parse( this.__settings );
    }

    this.settings = overrideSettings( this.settings, settings );
  }

  render() {
    const availableTimes = [];
    const hours = 12;
    const minutes = [
      '00',
      15,
      30,
      45
    ];
    for ( let i = 1; i <= hours; i++ ) {
      minutes.forEach( minute => {
        availableTimes.push( `${i}:${minute}` );
      });
    }
    return (
      <div>
        <input id='datepicker' placeholder='Select Date' />
        {!this.__dateonly && 
          <select name="time" id="time" onInput={ e => { this.handleTimeChange(e) } }>
            {availableTimes.map( time => <option value={time} selected={this.time === time}>{time}</option>)}
          </select>
        }
        {!this.__dateonly && 
          <select name="station" id="station" onInput={ e => { this.handleStationChange(e) } }>
            <option value='PM' selected={this.station === 'PM'}>PM</option>
            <option value='AM' selected={this.station === 'AM'}>AM</option>
          </select>
        }
        {!this.__dateonly &&
          <select name="timezone" id="timezone" onInput={ e => { this.handleTimezoneChange(e) } }>
            <option value='None' selected={this.timezone === 'None'}>No Timezone</option>
            <option value='America/Los_Angeles' selected={this.timezone === 'America/Los_Angeles'}>Pacific</option>
            <option value='America/New_York' selected={this.timezone === 'America/New_York'}>Eastern</option>
            <option value='America/Denver' selected={this.timezone === 'America/Denver'}>Mountain</option>
            <option value='America/Chicago' selected={this.timezone === 'America/Chicago'}>Central</option>
            <option value='America/Anchorage' selected={this.timezone === 'America/Anchorage'}>Alaskan</option>
            <option value='America/Adak' selected={this.timezone === 'America/Adak'}>Hawaiian</option>
            <option value='America/Halifax' selected={this.timezone === 'America/Halifax'}>Atlantic</option>
            <option value='America/St_Johns' selected={this.timezone === 'America/St_Johns'}>New Foundland</option>
          </select>
        }
      </div>
    );
  }
}
